import {AfterViewInit, Component} from '@angular/core';
import {DeliveryAddressConfirmFragmentController} from './DeliveryAddressConfirmFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {ExamAfterProcessInitialDataDTOInterface} from '../../../../../../DTO/ExamAfterProcessInitialDataDTOInterface';
import {PrescriptionDeliveryTargetConst} from '../../../../../../Enum/PrescriptionDeliveryTargetConst';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './DeliveryAddressConfirmFragmentComponent.html',
	styleUrls: ['../ExamAfterProcessLayout.scss', './DeliveryAddressConfirmFragmentComponent.scss'],
})

export class DeliveryAddressConfirmFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: DeliveryAddressConfirmFragmentController;
	public eventPrevPage: () => void;

	public data: ExamAfterProcessInitialDataDTOInterface = {
		examAfterProcess: {
			id: 1,
			userId: 0,
			paymentId: 0,
			reservationId: 0,
			isMedicine: 0,
			isPrescription: 0,
			prescriptionAddressId: 0,
			prescriptionDeliveryTarget: 5,
			medicineAddressId: 0,
			status: 0,
			hash: null,
		},
		user: {
			id: 0,
			lineId: '',
			lineTokenId: 0,
			lastname: '',
			middlename: '',
			firstname: '',
			lastnameKana: '',
			firstnameKana: '',
			nameRoman: null,
			passportNo: null,
			nationalityId: null,
			gender: '',
			birthday: '',
			telNumber: '',
			deviceType: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			email: '',
			password: '',
			anonymousCode: 1,
			userNotes: '',
		},
		payment: {
			id: 0,
			userId: 0,
			orcaUsername: null,
			orcaPatient: null,
			itemPrice: 0,
			processCode: '',
			state: 0,
			paymentCode: null,
			conveniState: 0,
			conveniName: null,
			payFlag: 0,
			processUrl: '',
			performDate: null,
			remark: null,
			receiptId: null,
			reservationId: null,
			isDirty: false,
			isMerged: false,
			mergedId: null,
			isHide: false,
		},
		primaryAddress: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
			displayToName: '',
		},
		isValidPrimaryAddress: false,
		storeAddressList: [],
		homeAddressList: [],
		selectedPrescriptionDeliveryAddress: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
			displayToName: '',
		},
		selectedPrescriptionFaxStore: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
			displayToName: '',
		},
		selectedMedicineDeliveryAddress: {
			id: 0,
			userId: 0,
			storeName: '',
			postCode: '',
			prefecture: '',
			city: '',
			address: '',
			building: '',
			toName: '',
			telNumber: '',
			faxNumber: '',
			displayToName: '',
		},
		countAvailableMedicineDeliveryAddress: 0,
		countAvailableStoreDeliveryAddress: 0,
		isInputComplete: false,
		epsilon: {
			id: 0,
			paymentId: 0,
			itemCode: '',
			itemName: '',
			itemPrice: 0,
			stCode: '',
			missionCode: '',
			processCode: '',
			state: 0,
			paymentCode: 0,
			conveniState: 0,
			conveniName: '',
			processUrl: '',
			payFlag: 0,
		}
	};

	// お薬、処方箋の送付なし
	public isNoItemToDelivery = false;

	// 支払いURLがある場合true
	public isPaymentUrl = false;
	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(DeliveryAddressConfirmFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
	}


	/**
	 * 開始処理
	 */
	public async start() {
		this.log('DeliveryAddressConfirmFragmentComponent::start()');
		this.log(this.data);
		// お薬、処方箋どちらも無い場合
		if (this.data.examAfterProcess.isMedicine === 0 && this.data.examAfterProcess.isPrescription === 0) {
			this.isNoItemToDelivery = true;
		}

		// URLの生成チェック
		if (this.data.epsilon.processUrl !== '') {
			this.isPaymentUrl = true;
		}
	}

	/**
	 * 次へ
	 */
	public async onClickPrevPage(): Promise<void> {
		await this.eventPrevPage();
	}

	/**
	 * 支払いURLが無い場合(最初のクリック時)URLを生成
	 */
	public async onClickPayment(): Promise<void> {
		const res = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.createPaymentUrl.bind(this),
			{view: this, paymentId: this.data.payment.id}
		);

		location.href = res.processUrl;
	}

	public async setInitialData(data: ExamAfterProcessInitialDataDTOInterface): Promise<void> {
		this.data = data;
	}

	protected readonly PrescriptionDeliveryTargetConst = PrescriptionDeliveryTargetConst;
}

